import { render, staticRenderFns } from "./page12.vue?vue&type=template&id=1c5f1d03"
import script from "./page12.vue?vue&type=script&lang=js"
export * from "./page12.vue?vue&type=script&lang=js"
import style0 from "./page12.vue?vue&type=style&index=0&id=1c5f1d03&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports